<template>
  <div id="newsletter">
    <div v-if="!isMissing" class="w-full mx-4">
      <div class="text-gray-500 ml-4 font-display font-bold mb-2">Zapisz się do newslettera</div>
      <p class="text-gray-500 ml-4 leading-normal">Otrzymuj informacje o nowych przemówieniach, podcastach i innych ciekawych materiałach</p>
      <div class="ml-form-embed" data-account="1766778:v7f8w1j5f0" data-form="5164793:c7w1m7" />
    </div>
    <div v-else class="w-full mx-2 pr-4 my-4">
      <div class="text-gray-500 font-bold mb-2 ml-4">Zapisz się do newslettera</div>
      <p class="text-gray-500 leading-normal ml-4"> Wygląda na to, że tego mówcy jeszcze nie opisaliśmy na naszej stronie:( Ale postaramy się, by wkrótce to się zmieniło. Jeśli chcesz dostać informację o nowych wpisach - zapraszamy do naszego newslettera. Będziemy w nim zawiadamiać o zmianach na stronie:) </p>
      <div class="ml-form-embed" data-account="1766778:v7f8w1j5f0" data-form="5164670:y6p0u6"/>
    </div>
  </div>
</template>

<script>

export default {
    name: 'Newsletter',
    data() {
        return{
        }
    },
    mounted: function() {
        (function(m, a, i, l, e, r) {
            m["MailerLiteObject"] = e;
            function f() {
                var c = { a: arguments, q: [] };
                var r = this.push(c);
                return "number" != typeof r ? r : f.bind(c.q);
            }
            f.q = f.q || [];
            m[e] = m[e] || f.bind(f.q);
            m[e].q = m[e].q || f.q;
            r = a.createElement(i);
            var _ = a.getElementsByTagName(i)[0];
            r.async = 1;
            r.src = l + "?v" + ~~(new Date().getTime() / 1000000);
            _.parentNode.insertBefore(r, _);
        })(
            window,
            document,
            "script",
            "https://static.mailerlite.com/js/universal.js",
      "ml"
    );        
        var ml_account = ml('accounts', '1766778', 'v7f8w1j5f0', 'load');

    },
    props: {
        isMissing: {
            type: Boolean
        },
    }
}
</script>
